import { LazyLoadImage } from 'react-lazy-load-image-component'

import dmca from '../../assets/footer/dmca.webp'
import egba from '../../assets/footer/egba.webp'
import gamble_aware from '../../assets/footer/gamble_aware.webp'
import gambling_commission from '../../assets/footer/gambling_commission.webp'
import gambling_therapy from '../../assets/footer/gambling_therapy.webp'
import gamcare from '../../assets/footer/gamcare.webp'
import gamstop from '../../assets/footer/gamstop.webp'
import ibas from '../../assets/footer/ibas.webp'
import plus_18_logo from '../../assets/footer/plus_18_logo.webp'

const SUPPORT_LOGOS = [
  {
    url: 'https://www.dmca.com/',
    logo: dmca,
    aspectRatio: '143 / 45',
  },
  {
    url: 'https://www.egba.eu/',
    logo: egba,
    aspectRatio: '5255 / 634',
  },
  {
    url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/38898',
    logo: gambling_commission,
    aspectRatio: '5921 / 1600',
  },
  {
    url: 'https://www.gambleaware.org/',
    logo: gamble_aware,
    aspectRatio: '2318 / 307',
  },
  {
    url: 'https://www.gamblingtherapy.org/',
    logo: gambling_therapy,
    aspectRatio: '2406 / 743',
  },
  {
    url: 'https://www.gamcare.org.uk/',
    logo: gamcare,
    aspectRatio: '484 / 139',
  },
  {
    url: 'https://www.gamstop.co.uk/',
    logo: gamstop,
    aspectRatio: '463 / 84',
  },
  {
    url: 'https://ibas-uk.com/',
    logo: ibas,
    aspectRatio: '4041 / 1432',
  },
]

const Copyrights = () => {
  return (
    <div className="text-center text-xs font-normal text-highlight pb-[50px] px-5 py-0 xl:px-[30px] xl:py-0">
      <div className="mb-[30px] pt-0 pb-[25px] px-0 border-b-highlight border-b border-solid xl:pb-2.5 xl:border-b-0">
        <div>
          <div className="flx-ctr flex-wrap gap-4 xl:gap-6 xl:p-0">
            {SUPPORT_LOGOS.map(support => (
              <a
                key={support.url}
                href={support.url}
                target="blank"
                aria-label="Gambling Therapy">
                <LazyLoadImage
                  className="h-[25px] xl:h-[45px]"
                  src={support.logo}
                  alt="Gambling Therapy Logo"
                  style={{ aspectRatio: support.aspectRatio }}
                />
              </a>
            ))}
            <span className="inline-flex">
              <LazyLoadImage
                className="h-[33px] xl:h-[45px] mr-1 aspect-square"
                src={plus_18_logo}
                alt={'18 plus'}
              />
            </span>
          </div>
        </div>
      </div>
      <p className="mb-2">
        FUN88 está gestionado por TGP Europe Ltd, con domicilio en 22A Castle
        Street, Douglas, Isle of Man, IM1 2EZ. TGP Europe Limited está
        autorizado y regulado en Gran Bretaña por la Comisión de Apuestas bajo
        el número de cuenta 38898.
      </p>
      <p className="mb-2">
        FUN88 opera en México a través de Producciones Móviles S.A. de C.V.,
        titular del permiso DGAJS/SCEVF/P-06/2005-TER, en colaboración con
        Unocapali La Paz Operadora S.A. de C.V., de acuerdo con los oficios
        DGJS/1580/2021 y DGJS/DCRCA/1424/2022.
      </p>
      <p className="mb-2">
        FUN88 es operado por E Gambling Montenegro doo (81000 Podgorica,
        Moskovska br. 65., reg. No. 5-0615951) en cooperación con OG GLOBAL
        ACCESS LIMITED (PO Box 3340, Road Town, Tortola, Islas Vírgenes
        Británicas).
      </p>
      <p className="mb-2">
        E Gambling Montenegro doo (81000 Podgorica, Moskovska br. 65., reg. No.
        5-0615951) certifica que, bajo la concesión (número de serie AA 001588,
        número numérico 133-01/15 4A y 1er) y la aprobación (No. 02/01-118/4),
        organiza y opera juegos de azar en Montenegro en el sitio web FUN88, de
        conformidad con el acuerdo celebrado entre E Gambling Montenegro doo y
        OG GLOBAL ACCESS LIMITED (PO Box 3340, Road Town, Tortola, Islas
        Vírgenes Británicas, reg. No. 1923130) el 7 de octubre de 2021.
      </p>
      <p className="mb-2">
        FUN88 es operado por OG GLOBAL ACCESS LIMITED. Regulado y autorizado
        desde el 7 de octubre de 2021 por E-Gambling Montenegro. Copyright
        FUN88©
      </p>
      <p className="mb-2">
        Está estrictamente prohibido el acceso a esta página a menores de 18
        años. El juego por parte de menores es un delito. Juegue de manera
        responsable y recuerde que el propósito principal es la recreación, la
        diversión y el entretenimiento.
      </p>
    </div>
  )
}

export default Copyrights
